"use strict";
exports.__esModule = true;
exports.chart_axis_axis_Fill = {
  "name": "--pf-chart-axis--axis--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-axis--axis--Fill, transparent)"
};
exports["default"] = exports.chart_axis_axis_Fill;